module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/@babel/runtime/regenerator/index.js
// module id = FOhS
// module chunks = 0471